import React from 'react'
import { connect } from 'react-redux'
import subjects from '~/comm'
import { setSearchTerm } from '~/menu/actions.js'

class Search extends React.Component {
  constructor(props) {
    super(props)
    this.search = null
    // Setting up initial state
    this.state = {
      currentComponent: 'coming...',
    }
    subjects.currentComponent.subscribe(x => this.currentComponent(x) )
    this.searchMenu = this.searchMenu.bind(this)
    this.doIT = this.doIT.bind(this)
  }

  currentComponent(x){
    this.setState({ currentComponent: x })
  }

  doIT(event){
    console.log(event)
    console.log(this.search)
    const { dispatch } = this.props
    event.preventDefault()
    //subjects.menuSearch.next(this.search)
    dispatch(setSearchTerm(this.search))
  }

  searchMenu(event){
    console.log(event.target.value)
    this.search = event.target.value
    if(event.target.value.length === 0) {
      console.log('CLEARED')
    }
  }

  render() {
    if (this.props.currentComponent === 'Programs' || this.props.currentComponent === 'Albums')
    { return (
      <li style={{float: 'right'}}>
        <form onSubmit={this.doIT}><input onChange={this.searchMenu} placeholder={'search ' + this.state.currentComponent} name="search" type="text" /></form>
        <i style={{lineHeight: '42px'}} className="fa fa-search" aria-hidden="true"></i>
      </li>
    )
    }
    else {
      return null
    }
  }
}
export default connect(state => ({search: state.search})) (Search)
